export default {
  list: [],
  current: 'en_US',
  error: null,
  isLoading: false,
};
